'use strict';

module.exports = function (ngModule) {
    require('./css')();
}


/** WEBPACK FOOTER **
 ** ./src/system/assets/index.js
 **/